import { TAppState } from '../../types/appState';
import { currentOpenChatSelector } from '../currentOpenChatSelector';

export function currentChatOpponentIdSelector(state: TAppState): number | undefined {
  const currentChat = currentOpenChatSelector(state);

  const { users } = currentChat || {};

  const opponent = users?.find(user => user.chatRole === 'opponent');

  return opponent?.userId;
}
